<template>
  <div>
    <v-dialog v-model="detailModal" max-width="800">
      <PatternDetail :patternId="selectedId" :key="selectedId" />
    </v-dialog>

    <div class="d-flex justify-end">
      <v-btn
        class="primary-button ml-2"
        depressed
        @click="showFilter = !showFilter"
      >
        {{ showFilter ? 'Fechar filtros' : 'Filtros' }}
      </v-btn>
    </div>

    <v-expand-transition>
      <div v-if="showFilter">
        <div class="my-2 d-flex justify-end align-center">
          <v-text-field
            v-model="filter.search"
            placeholder="Pesquise pelo nome do padrão, nome do equipamento ou identificação do equipamento"
            class="primary-input mt-4"
            outlined
            style="max-width: 700px"
            hide-details
          ></v-text-field>
          <v-btn
            class="ma-0 primary-button ml-2"
            depressed
            @click=";(page = 1), list()"
          >
            Filtrar
          </v-btn>
        </div>
      </div>
    </v-expand-transition>

    <v-data-table
      :headers="headers"
      :items="patterns"
      class="main-table"
      hide-default-footer
      :items-per-page="pageSize"
      :loading="loading"
      :header-props="headerProps"
    >
      <template #[`item.name`]="{ item }">
        {{ item.name }}
      </template>

      <template #[`item.propertyCode`]="{ item }">
        {{ item.propertyCode }}
      </template>

      <template #[`item.model`]="{ item }">
        {{ item.model }}
      </template>

      <template #[`item.manufacturer`]="{ item }">
        {{ item.manufacturer }}
      </template>

      <template #[`item.serialNumber`]="{ item }">
        {{ item.serialNumber }}
      </template>

      <template #[`item.expirationDate`]="{ item }">
        {{ formatDate(item.expirationDate) }}
      </template>

      <template #[`item.actions`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ma-1"
              small
              color="#f5f5f5"
              dark
              @click="openDetail(item)"
              v-bind="attrs"
              v-on="on"
              depressed
              x-small
            >
              <v-icon color="#bbcf20">mdi-eye-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Histórico de calibrações') }}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="institution.userType != 5 && institution.userType != 4"
              color="#0F3565"
              class="ma-1"
              dark
              small
              depressed
              v-bind="attrs"
              v-on="on"
              :to="`/electricalSafety/patternManage?id=${item.id}`"
            >
              <v-icon small>mdi-pencil-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Editar') }}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ma-1"
              :color="
                item.uploadedDocuments && item.uploadedDocuments.length != 0
                  ? '#BBCF20'
                  : '#f5f5f5'
              "
              dark
              @click="uploadDocument(item)"
              v-bind="attrs"
              v-on="on"
              depressed
              small
            >
              <span style="font-size: 0.9rem">
                {{
                  item.uploadedDocuments.length != 0
                    ? item.uploadedDocuments.length
                    : ''
                }}
              </span>
              <v-icon
                small
                :class="
                  item.uploadedDocuments && item.uploadedDocuments.length != 0
                    ? 'ml-1'
                    : ''
                "
                :color="
                  item.uploadedDocuments && item.uploadedDocuments.length != 0
                    ? '#fff'
                    : '#BBCF20'
                "
              >
                mdi-file-document-multiple-outline
              </v-icon>
            </v-btn>
          </template>
          <span>Documentos Anexados</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="institution.userType != 5 && institution.userType != 4"
              class="ma-1"
              color="#B14949"
              dark
              small
              depressed
              @click.stop="deletePattern(item)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon small> mdi-delete </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Excluir') }}</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <div class="pagination">
      <div class="item-pagination block-one">
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="btn"
              depressed
              color="#C0C0C0"
              small
            >
              qtd: {{ pageSize }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(size, i) in sizes"
              :key="i"
              @click="pageSize = size"
            >
              <v-list-item-title>{{ size }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <div class="registros" v-if="totalItensOnPage">
          <span> 1 - {{ totalItensOnPage }} de {{ totalItems }} </span>
        </div>
      </div>

      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="page"
          :length="totalPages"
          :total-visible="9"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ApiService from '../../../../services/ApiService'
import PatternDetail from './patternDetail.vue'

export default {
  name: 'institutionPatternTable',

  components: {
    PatternDetail,
  },

  data() {
    return {
      showFilter: false,
      patterns: [],
      pageSize: 10,
      sizes: [10, 25, 50],
      totalItems: 4,
      totalItensOnPage: 4,
      totalPages: 1,
      page: 1,
      loading: false,
      institution: null,
      filter: {
        page: 1,
        pageSize: 10,
      },
      apiService: new ApiService(),
      headerProps: {
        sortByText: 'Ordenar por',
      },
      headers: [
        { text: '', align: 'center', value: '', sortable: false },
        { text: 'Padrão', align: 'center', value: 'name', sortable: false },
        {
          text: 'Código Patrimônio',
          align: 'center',
          value: 'equipment.propertyCode',
          sortable: false,
        },
        {
          text: 'Modelo',
          align: 'center',
          value: 'equipment.model',
          sortable: false,
        },
        {
          text: 'Fabricante',
          align: 'center',
          value: 'equipment.manufacturer',
          sortable: false,
        },
        {
          text: 'Nº Série',
          align: 'center',
          value: 'equipment.serialNumber',
          sortable: false,
        },
        {
          text: 'Validade',
          align: 'center',
          value: 'expirationDate',
          sortable: false,
        },
        {
          text: 'Ações',
          align: 'center',
          value: 'actions',
          sortable: false,
        },
      ],
      selectedId: null,
      detailModal: false,
    }
  },

  created() {
    this.filter.institutionId = JSON.parse(
      localStorage.getItem('institution')
    ).id
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.list()
  },

  methods: {
    uploadDocument(pattern) {
      sessionStorage.clear()
      sessionStorage.setItem('electricalSafetyPattern', JSON.stringify(pattern))
      this.$router.push({ path: '/uploadDocument' })
    },

    openDetail(item) {
      this.selectedId = item.id
      this.detailModal = true
    },

    list() {
      this.loading = true
      this.apiService
        .get('electricalSafetyPattern/list', this.filter)
        .then((response) => {
          this.loading = false
          this.patterns = response.content.data
          this.totalItems = response.content.pager.totalItems
        })
        .catch(() => {
          this.loading = false
        })
    },

    deletePattern(item) {
      this.loading = true
      this.apiService
        .delete(`electricalSafetyPattern/${item.id}`)
        .then(() => {
          this.loading = false
          this.$toast.success('Padrão excluído com sucesso!')
          this.list()
        })
        .catch(() => {
          this.loading = false
          this.$toast.error('Erro ao excluir o padrão.')
        })
    },

    formatDate(date) {
      if (date) return moment(date).format('DD/MM/yyyy')
      else return 'Sem registro'
    },

    viewItem(item) {
      console.log('Visualizar item', item)
    },
  },

  watch: {
    page() {
      this.filter.page = this.page
      this.list()
    },

    pageSize() {
      this.filter.pageSize = this.pageSize
      this.list()
    },
  },
}
</script>

<style></style>
